import * as tslib_1 from "tslib";
import { ValueField } from './value_fields';
var TimeBox = /** @class */ (function (_super) {
    tslib_1.__extends(TimeBox, _super);
    function TimeBox(param) {
        return _super.call(this, param) || this;
    }
    TimeBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TimeBox" });
    };
    TimeBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TimeBox;
}(ValueField));
export { TimeBox };
//# sourceMappingURL=time_box.js.map